var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaypalRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1439 6.06775C21.1424 6.07764 21.142 6.07991 21.1394 6.09757C21.1394 6.09757 21.1416 6.08319 21.1439 6.06775Z",
    fill: "#DE6139"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1434 6.06774C21.1503 6.02191 21.1475 6.04051 21.1434 6.06774V6.06774Z",
    fill: "#DE6139"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1215 1.80966C19.0039 0.54304 16.9837 0 14.3993 0H6.89854C6.36979 0 5.92045 0.38238 5.8377 0.90086L2.71452 20.597C2.65246 20.9854 2.9549 21.3372 3.35077 21.3372H7.98143L9.14444 14.0022L9.10837 14.2319C9.19117 13.7134 9.63712 13.331 10.1652 13.331H12.3657C16.6886 13.331 20.0735 11.5851 21.0622 6.53438C21.0916 6.38503 21.139 6.09758 21.139 6.09758C21.4194 4.22865 21.137 2.96016 20.1215 1.80966Z",
    fill: "#DE6139"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3107 7.05402C21.2355 12.0265 17.806 14.6585 12.3654 14.6585H10.3918L8.92017 24H12.1211C12.5831 24 12.9763 23.6654 13.0484 23.212L13.0865 23.0141L13.8222 18.3777L13.8696 18.1215C13.9417 17.668 14.3349 17.3335 14.7969 17.3335H15.3811C19.1625 17.3335 22.1234 15.8059 22.9887 11.3879C23.3354 9.61547 23.1693 8.12843 22.3107 7.05402Z",
    fill: "#DE6139"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypalRed);
export default __webpack_public_path__ + "static/media/paypal-red.a1752c9f.svg";
export { ForwardRef as ReactComponent };